import React, { useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2';
import { db } from '../../firebase';
import {
    Timestamp,
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    onSnapshot,
    query,
    updateDoc,
    where,
} from 'firebase/firestore';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import moment from 'moment';
import { useParams } from 'react-router-dom';

import Payroleheader from './Payroleheader';

import {
    Box,
    Grid,
    Typography,
    Card,
    CardContent,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@mui/material';

// ... import statements remain the same

function StaffAttendance() {
    const param = useParams();
    const staffid = param.staffid;

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        },
    });

    const [staffname, setstaffname] = useState('');
    const [totpresent, settotpresent] = useState(0);
    const [totabsent, settotabsent] = useState(0);
    const [totalHalfDays, setTotalHalfDays] = useState(0); // <-- half day count
    const [monthpayment, setmonthpayment] = useState(0);
    const [thismonthpay, setthismonthpay] = useState(0);
    const [attds, setattds] = useState([]);
    const [status, setstatus] = useState('Present');
    const [load, setload] = useState(true);
    const [date, setdate] = useState('');
    const [attendanceData, setAttendanceData] = useState([]);

    const [selectedMonth, setSelectedMonth] = useState(moment());


    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);
    const handleShow = () => setOpen(true);

    const calendarRef = useRef(null);

    useEffect(() => {
        fetchData();

        if (calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            calendarApi.gotoDate(selectedMonth.format("YYYY-MM-DD"));
            fetchData();
        }
    }, [selectedMonth]);

    const fetchData = async () => {
        try {
            const startOfMonth = selectedMonth.startOf("month").format("YYYY-MM-DD");
            const endOfMonth = selectedMonth.endOf("month").format("YYYY-MM-DD");

            // Attendance List for Calendar
            const q1 = query(
                collection(db, 'attendance'),
                where('staffId', '==', staffid),
                where('date', '>=', startOfMonth),
                where('date', '<=', endOfMonth)
            );
            onSnapshot(q1, (querySnapshot1) => {
                const combinedData = querySnapshot1.docs.map(doc1 => {
                    const data = doc1.data();
                    const dateStr = typeof data.date === 'string'
                        ? data.date
                        : data.date?.toDate
                            ? moment(data.date.toDate()).format('YYYY-MM-DD')
                            : '';

                    let color = 'red';
                    if (data.status === 'Present') color = 'green';
                    if (data.status === 'Half Day') color = 'orange';

                    return {
                        id: doc1.id,
                        ...data,
                        date: dateStr,
                        title: data.status,
                        start: dateStr,
                        color,
                    };
                });

                setattds(combinedData);
                setAttendanceData(combinedData);
            });

            // Staff details
            const docRef = doc(db, 'staffdetails', staffid);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const monthlySalary = parseFloat(docSnap.data().monthlypayment) || 0;
                setstaffname(docSnap.data().staffname);
                setmonthpayment(monthlySalary);

                // ✅ Salary per day based on selected month
                const perdayamount = monthlySalary / selectedMonth.daysInMonth();
                setthismonthpay(perdayamount);
            }

            // Present count
            const q2 = query(
                collection(db, 'attendance'),
                where('staffId', '==', staffid),
                where('status', '==', 'Present'),
                where('date', '>=', startOfMonth),
                where('date', '<=', endOfMonth)
            );
            onSnapshot(q2, (snapshot) => settotpresent(snapshot.size));

            // Absent Count
            const q3 = query(
                collection(db, 'attendance'),
                where('staffId', '==', staffid),
                where('status', '==', 'Absent'),
                where('date', '>=', startOfMonth),
                where('date', '<=', endOfMonth)
            );
            onSnapshot(q3, (snapshot) => settotabsent(snapshot.size));

            // Half-Day Count
            const q4 = query(
                collection(db, 'attendance'),
                where('staffId', '==', staffid),
                where('status', '==', 'Half Day'),
                where('date', '>=', startOfMonth),
                where('date', '<=', endOfMonth)
            );
            onSnapshot(q4, (snapshot) => setTotalHalfDays(snapshot.size));

        } catch (error) {
            Toast.fire({ icon: 'error', title: error.message });
        }
    };

    const handleDateClick = (arg) => {
        const clickedDate = moment(arg.dateStr).format('YYYY-MM-DD');
        setdate(clickedDate);

        const existing = attendanceData.find(a => a.date === clickedDate);
        setstatus(existing ? existing.status : 'Present');

        handleShow();
    };

    const handleSubmit = async () => {
        if (!staffid || !date || !status) {
            Toast.fire({ icon: 'error', title: 'Please fill the required fields' });
            return;
        }

        try {
            const formattedDate = moment(date).format('YYYY-MM-DD');

            const q = query(
                collection(db, 'attendance'),
                where('staffId', '==', staffid),
                where('date', '==', formattedDate)
            );
            const snapshot = await getDocs(q);

            if (!snapshot.empty) {
                const docId = snapshot.docs[0].id;
                await updateDoc(doc(db, 'attendance', docId), {
                    status,
                    updatedAt: Timestamp.now()
                });
            } else {
                await addDoc(collection(db, 'attendance'), {
                    staffId: staffid,
                    date: formattedDate,
                    status,
                    createdAt: Timestamp.now()
                });
            }

            Toast.fire({ icon: 'success', title: 'Attendance Saved Successfully!!' });
            handleClose();
        } catch (error) {
            Toast.fire({ icon: 'error', title: error.message || 'Something went wrong' });
        }
    };

    // Calculate salary for current month
    const totalSalary = (totpresent * thismonthpay) + (totalHalfDays * thismonthpay * 0.5);

    return (
        <Box p={3}>
            <Payroleheader />
            <Box mb={2} display="flex" justifyContent="flex-end">
                <Button variant="contained" color="secondary" onClick={handleShow}>
                    Add Attendance
                </Button>
            </Box>

            <Box mb={2} display="flex" justifyContent="center" gap={2}>
                <Button
                    variant="outlined"
                    onClick={() => setSelectedMonth(prev => moment(prev).subtract(1, "month"))}
                >
                    ⬅ Previous
                </Button>

                <Typography variant="h6" fontWeight="bold">
                    {selectedMonth.format("MMMM YYYY")}
                </Typography>

                <Button
                    variant="outlined"
                    onClick={() => setSelectedMonth(prev => moment(prev).add(1, "month"))}
                >
                    Next ➡
                </Button>
            </Box>


            {/* Stats Section */}
            <Card sx={{ mb: 3, borderRadius: 3, boxShadow: 3, p: 2 }}>
                <CardContent>
                    <Grid container spacing={3} justifyContent="center">
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography variant="subtitle2" color="textSecondary">Staff Name</Typography>
                            <Typography variant="h6" fontWeight="bold">{staffname}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography variant="subtitle2" color="textSecondary">Total Present</Typography>
                            <Typography variant="h6" color="green" fontWeight="bold">{totpresent} Days</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography variant="subtitle2" color="textSecondary">Half Days</Typography>
                            <Typography variant="h6" color="orange" fontWeight="bold">{totalHalfDays} Days</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography variant="subtitle2" color="textSecondary">Total Absent</Typography>
                            <Typography variant="h6" color="red" fontWeight="bold">{totabsent} Days</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography variant="subtitle2" color="textSecondary">Month</Typography>
                            <Typography variant="h6" fontWeight="bold">{selectedMonth.format("MMM")}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography variant="subtitle2" color="textSecondary">Salary This Month</Typography>
                            <Typography variant="h6" fontWeight="bold">₹{totalSalary.toFixed(0)}</Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            {/* Calendar */}
            <Card>
                <CardContent sx={{ "& .fc-daygrid-day": { border: "1px solid #ccc", borderRadius: "4px" } }}>
                    <FullCalendar
                        ref={calendarRef}
                        plugins={[bootstrapPlugin, dayGridPlugin, interactionPlugin]}
                        initialView="dayGridMonth"
                        initialDate={selectedMonth.format("YYYY-MM-DD")}
                        themeSystem="bootstrap"
                        headerToolbar={{ center: '', end: 'dayGridMonth' }}
                        events={attds}
                        timeZone="Asia/Kolkata"
                        height="80vh"
                        dateClick={handleDateClick}
                        eventClick={handleDateClick}
                    />
                </CardContent>
            </Card>

            {/* Attendance Dialog */}
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Add Attendance</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth margin="normal">
                        <InputLabel>Status</InputLabel>
                        <Select value={status} onChange={(e) => setstatus(e.target.value)}>
                            <MenuItem value="Present">Present</MenuItem>
                            <MenuItem value="Absent">Absent</MenuItem>
                            <MenuItem value="Half Day">Half Day</MenuItem>
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSubmit}>Submit</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

export default StaffAttendance;
